import React from "react"
import { TouchableOpacity, StyleSheet, Text, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"

/**
 * Chip de sélection de MOIS pour le configurateur Cours d'été.
 *
 * Variante à fort contraste de BrevetChip : le state sélectionné doit être
 * NETTEMENT distinguable du non-sélectionné (juillet/août sont des choix
 * binaires importants pour le parent). On marque le sélectionné par :
 *  - bordure `primary` (même épaisseur/rayon que les chips matières & créneaux),
 *  - fond `primaryLighter` (pastel de marque),
 *  - une pastille check pleine `primary` à gauche,
 *  - label en gras `primary`.
 * Le non-sélectionné reste sobre : bordure claire, fond blanc, label grey.
 */
const SummerMonthChip = ({ label, selected, onPress }) => (
    <TouchableOpacity
        onPress={onPress}
        activeOpacity={0.7}
        accessibilityRole="button"
        accessibilityState={{ selected }}
        style={[styles.chip, selected && styles.chipSelected]}
    >
        <View style={styles.row}>
            <View style={[styles.dot, selected && styles.dotSelected]}>
                {selected ? (
                    <FontAwesome5 name="check" size={9} color={theme.colors.white} />
                ) : null}
            </View>
            <Text style={[styles.label, selected && styles.labelSelected]}>
                {label}
            </Text>
        </View>
    </TouchableOpacity>
)

const styles = StyleSheet.create({
    chip: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 14,
        borderWidth: 1.5,
        borderColor: theme.colors.lightMore,
        backgroundColor: theme.colors.white,
        // Même relief/rayon/épaisseur que ClassChipGridM (matières & créneaux)
        // pour une cohérence parfaite des pastilles du configurateur.
        shadowColor: "#000",
        shadowOpacity: 0.04,
        shadowRadius: 6,
        shadowOffset: { width: 0, height: 2 },
    },
    chipSelected: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primaryLighter,
    },
    row: { flexDirection: "row", alignItems: "center", gap: 8 },
    // Pastille check : creuse (bordure grey) au repos, pleine primary sélectionnée.
    dot: {
        width: 16,
        height: 16,
        borderRadius: 8,
        borderWidth: 1.5,
        borderColor: theme.colors.light,
        backgroundColor: theme.colors.white,
        alignItems: "center",
        justifyContent: "center",
    },
    dotSelected: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primary,
    },
    label: {
        fontFamily: "Montserrat-Medium",
        fontSize: 14,
        color: theme.colors.grey,
    },
    labelSelected: {
        fontFamily: "Montserrat-Bold",
        color: theme.colors.primary,
    },
})

export default SummerMonthChip
